import BaseColors from '@/atoms/colors/Base';
import CardColors from '@/atoms/colors/Card';
import Shadow from '@/atoms/colors/Shadow';
import Box from '@mui/material/Box';
import Grow from '@mui/material/Grow';
import Stack from '@mui/material/Stack';
import AiTooltip from '@/components/Copilot/components/Tooltip/Tooltip';
import CardFooter from './CardFooter';
import CardHeader from './CardHeader';

const OutlineCard = ({
  actionText,
  justifyContent = 'center',
  children,
  headerAction,
  information,
  isInformationModal,
  isTitleAction,
  margin = 2,
  onClick,
  padding = 2,
  title,
  showComparison,
  comparisonColor,
  prompt,
}) => {
  // Create a combined header action that includes both the original action and the AI tooltip if needed
  const combinedHeaderAction = prompt ? (
    <Stack direction="row" alignItems="center" spacing={2}>
      <span style={{ marginLeft: '8px' }}>
        <AiTooltip prompt={prompt} />
      </span>
      {headerAction}
    </Stack>
  ) : (
    headerAction
  );

  return (
    <Grow in={true} timeout={500}>
      <Box
        sx={{
          borderRadius: '4px',
          backgroundColor: CardColors.outline.backgroundColor,
          border: `1px solid ${CardColors.outline.borderColor}`,
          boxShadow: Shadow.low,
          height: '100%',
          color: BaseColors.font.primary,
          borderLeft: showComparison
            ? `4px solid ${comparisonColor?.fill}`
            : 'none',
        }}
      >
        <Stack justifyContent={justifyContent} sx={{ height: '100%' }}>
          {(Boolean(title) || Boolean(headerAction)) && (
            <CardHeader
              information={information}
              isInformationModal={isInformationModal}
              isTitleAction={isTitleAction}
              title={title}
              action={combinedHeaderAction}
            />
          )}
          <Box sx={{ px: padding, mt: margin, mb: onClick ? 0 : margin }}>
            {children}
          </Box>
          {Boolean(onClick) && (
            <Box sx={{ px: padding, mt: 3, mb: onClick ? margin : 0 }}>
              <CardFooter actionText={actionText} onClick={onClick} />
            </Box>
          )}
        </Stack>
      </Box>
    </Grow>
  );
};

export default OutlineCard;
